<template>
  <div class="page-wrapper" >
    <div class="container" v-if="pickup != ''">

      <div class="logo-row">
      <img src="@/assets/images/logo/NudgPay.png" alt="Nudg Logo" class="logo" />

      </div>
      <div class="content-row">

      <div class="left-column">
        <h1>Download The APP <span class="highlight">24/7</span></h1>
        <p class="note">
          Your Taxi, Booked, Dispatched & Delivered upon request at any time. We
          work round the clock to ensure you get to your destination as quick as
          possible.
        </p>
        <div v-if="!is_archived && payment_done_case" class="receipt-box">
          <input type="email" placeholder="Recipient's Email"  name="email" v-model="email" class="input-email">
          <button class="pay-now" @click="getReciept">Payment Receipt</button>
        </div>
      </div>


        <div class="right-column">
          <div class="card">
            <div class="heading-content-row ">
                <p class="heading-left-column">
                  Journey details
                </p>
                <div v-show="(!is_archived && !checkaccount) || (!is_archived && cashMeterJob)"  v-if="showEditing == true" class="heading-right-column">
                  <button  @click="editClick" class="track-btn edit-btn">Edit Booking</button>
                
                </div>
            </div>

            <div class="details">
              <div class="row">
                <span class="label">Booking ID</span>
                <span class="booking-value">{{ decryptedBookingId }}</span>
              </div>
              <div class="row">
                <span class="label">Pick Up</span>
                <span class="value ml-20">{{ pickup }}</span>
              </div>
              <div class="row">
                <span class="label">Drop Off</span>
                <span class="value ml-20" >{{ destination }}</span>
              </div>
              <div class="row">
                <span class="label">Pick Up Due Time</span>
                <span class="booking-value">{{ bookingPickupTime }}</span>
              </div>
            </div>

            <!-- //convert existing smspay logics here  -->

            <div v-if="manually_allowed_check">
              <!-- CHANGES BEGIN -->
              <!--  active and not dispatched -->

              <div
                class="row"
                v-show="status == 'active' || status == 'booked' || status == 'offered'"
              >

                <div v-if="admin_allow_third_party">
                  <div class="booking-confirmation" v-if="payment_done_case">
                    <div class="gradient-border">
                      <h4 class="mb-4">PLEASE SHOW THIS TO YOUR DRIVER</h4>
                       <p>Amount Paid: &#163; {{ bookingPaymentAmount }} </p>
                      <p>Booking ID: {{ decryptedBookingId }}</p>
                      <p>AuthCode: {{ authcode }}</p>

                      <p v-if="status == 'booked' || status == 'active' || status == 'offered'">
                        PAID BEFORE JOURNEY
                      </p>
                      <p v-else v-show="showTracking">DRIVER CALLSIGN : {{ driverCallsign }}</p>

                    </div>

                    <div class="button-group">
                      <button class="pay-now" @click="redirectToDownloadPage()">Download App</button>
                      <button class="track-btn"  v-show="showTracking && !is_archived" @click="redirectToLiveTrackingPage()">Track Driver</button>
                    </div>
                  </div>
                  <div v-else-if="checkaccount">
                    <h3>
                      {{ this.accountBookingText }}
                    </h3>
                     <div class="button-group">
                        <button class="track-btn" v-show="showTracking && !is_archived" @click.prevent="redirectToLiveTrackingPage()"> Track Driver</button>
                      </div>
                  </div>
                  <div v-else-if="is_as_directed">
                    <h3>As directed booking not allowed</h3>
                  </div>
                  <div
                    v-else-if="
                      (!variable_cost && is_fixed_price && !checkaccount && (status == 'active' || status == 'offered'))
                      ||
                      ((status == 'booked' || status == 'offered') && !checkaccount)
                    "
                    class="panel panel-default widget-weather panel-body"
                  >
                    <div class="price-section">
                      <div class="price-section-textbox">
                        <div class="price-section-text-div">
                          <p>
                            Your {{ amount_type }} Price
                          </p>
                        </div>

                      </div>
                      <div class="price-section-value-div">
                        <p>£ {{ amount }}</p>
                      </div>
                    </div>
                    <form ref="paymentForm" :action="postUrl" method="post" v-if="reference" @submit.prevent="handleSubmit">
                      <div class="button-group">
                        <button class="pay-now" type="submit">Pay Now</button>

                        <button class="pay-now" @click.prevent="redirectToDownloadPage()">
                          Download App
                        </button>

                        <button class="track-btn" v-show="showTracking && !is_archived" @click.prevent="redirectToLiveTrackingPage()"> Track Driver</button>
                        <input
                          id="Reference"
                          name="Reference"
                          type="hidden"
                          :value="reference"
                        />
                      </div>
                    </form>
                    <div v-if="showCharityDiv && reference">
                      <ul class="demo-alignment">
                        <li>
                          <vs-checkbox v-model="payForCharity" />
                        </li>
                        <li @click="openCharityDescription">
                          {{ charityText }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div v-else-if="variable_cost && !is_fixed_price && status !='booked'">
                    <h3>
                      You have to wait till the journey comences as booking issss
                      variable booking .
                    </h3>
                  </div>
                  <div
                    v-else-if="(payment_type == null || payment_type == 'Cash') && !cashMeterJob"
                  >
                    <div class="mt-6 gap-4 flex justify-end">
                        <button class="pay-now" @click="redirectToDownloadPage()">Download App</button>
                        <button class="track-btn"  v-show="showTracking && !is_archived" @click="redirectToLiveTrackingPage()">Track Driver</button>
                    </div>
                    <h4 class="flex justify-center mt-4">You want to pay by card ?</h4>
                    <div class="flex gap-4 justify-center mt-4">
                        <button class="pay-now" @click="payByCard">Yes </button>
                        <button  class="pay-now" > No </button>
                    </div>
                  </div>
                </div>

                <div v-else>
                  <div class="booking-confirmation" v-if="payment_done_case">
                    <div class="gradient-border">
                      <h4 class="mb-4">PLEASE SHOW THIS TO YOUR DRIVER</h4>
                       <p>Amount Paid: &#163; {{ bookingPaymentAmount }} </p>
                      <p>Booking ID: {{ decryptedBookingId }}</p>
                      <p>AuthCode: {{ authcode }}</p>

                      <p v-if="status == 'booked' || status == 'active' || status == 'offered'">
                        PAID BEFORE JOURNEY
                      </p>
                      <p v-else v-show="showTracking"> DRIVER CALLSIGN : {{ driverCallsign }}</p>

                    </div>
                    <div class="buttons">
                      <button class="pay-now" @click="redirectToDownloadPage()">Download App</button>
                      <button class="track-btn"  v-show="showTracking && !is_archived" @click="redirectToLiveTrackingPage()">Track Driver</button>
                    </div>
                  </div>
                  <div v-else-if="is_as_directed">
                    <h3>As directed booking not allowed</h3>
                  </div>
                  <div v-else-if="checkaccount">
                    <h3>
                      {{ this.accountBookingText }}
                    </h3>
                    <div class="button-group">
                        <button class="track-btn" v-show="showTracking && !is_archived" @click.prevent="redirectToLiveTrackingPage()"> Track Driver</button>
                      </div>
                  </div>
                  <div
                    v-else-if="!variable_cost && is_fixed_price"
                    class="panel panel-default widget-weather panel-body"
                  >
                     <div class="price-section">
                      <div class="price-section-textbox">
                        <div class="price-section-text-div">
                          <p>
                            Your {{ amount_type }} Price
                          </p>
                        </div>

                      </div>
                      <div class="price-section-value-div">
                        <p>£ {{ amount }}</p>
                      </div>
                    </div>
                    <form ref="paymentForm" :action="postUrl" method="post" v-if="reference" @submit.prevent="handleSubmit">
                     <div class="button-group">
                        <button class="pay-now" type="submit">Pay Now</button>

                        <button class="pay-now" @click.prevent="redirectToDownloadPage()">
                          Download App
                        </button>
                        <button class="track-btn" v-show="showTracking && !is_archived" @click.prevent="redirectToLiveTrackingPage()"> Track Driver</button>
                        <input
                          id="Reference"
                          name="Reference"
                          type="hidden"
                          :value="reference"
                        />
                      </div>
                    </form>
                    <div
                      v-if="showCharityDiv && reference"
                      class="flex justify-center mt-7"
                    >
                      <ul class="demo-alignment">
                        <li>
                          <vs-checkbox v-model="payForCharity" />
                        </li>
                        <li @click="openCharityDescription">
                          {{ charityText }}
                        </li>
                      </ul>
                    </div>
                  </div>

                  <!-- TODO  pending test these two scenarios -->
                  <div v-else-if="variable_cost && !is_fixed_price">
                    <h3>Third party booking not allowed .</h3>
                  </div>
                </div>
              </div>

              <div
                class="row"
                v-show="
                  status == 'arrived' ||
                  status == 'pickedup' ||
                  status == 'dispatched'
                "
              >
                <div v-if="admin_allow_third_party">
                              <!--
                                /************************************************************************************************** */

                                /*********************************** FIXED PRICE *************************************************** */

                                /************************************************************************************************** */-->

                  <div v-if="is_fixed_price">

                    <div v-if="payment_done_case">
                      <div class="booking-confirmation">
                        <div class="gradient-border">
                          <h4 class="mb-4">PLEASE SHOW THIS TO YOUR DRIVER</h4>
                          <p>Amount Paid: &#163; {{ bookingPaymentAmount }} </p>
                          <p>Booking ID: {{ decryptedBookingId }}</p>
                          <p>AuthCode: {{ authcode }}</p>

                          <p  v-if="status == 'booked' || status == 'active' || status == 'offered'">
                            PAID BEFORE JOURNEY
                          </p>
                          <p v-else v-show="showTracking">DRIVER CALLSIGN : {{ driverCallsign }}</p>

                        </div>
                        <div class="buttons">
                          <button class="pay-now" @click="redirectToDownloadPage()">Download App</button>
                          <button class="track-btn"  v-show="showTracking &&  !is_archived" @click="redirectToLiveTrackingPage()">Track Driver</button>
                        </div>
                      </div>
                    </div>
                    <div v-else-if="checkaccount">
                      <h3>
                          {{ accountBookingText }}
                      </h3>
                      <div class="button-group">
                        <button class="track-btn" v-show="showTracking && !is_archived" @click.prevent="redirectToLiveTrackingPage()"> Track Driver</button>
                      </div>

                    </div>
                    <div v-else>
                      <div
                        v-if="(payment_type == null || payment_type == 'Cash') && !cashMeterJob"
                      >
                        <div class="mt-6 gap-4 flex justify-end">
                            <button class="pay-now" @click="redirectToDownloadPage()">Download App</button>
                            <button class="track-btn"  v-show="showTracking && !is_archived" @click="redirectToLiveTrackingPage()">Track Driver</button>
                        </div>
                        <h4 class="flex justify-center mt-4">You want to pay by card ?</h4>
                        <div class="flex gap-4 justify-center mt-4">
                            <button class="pay-now" @click="payByCard">Yes </button>
                            <button  class="pay-now" > No </button>
                        </div>
                      </div>
                      <div v-else-if="payment_type == 'Card'">
                        <div
                          v-if="amount"
                          class="panel panel-default widget-weather panel-body"
                        >
                          <div class="price-section">
                            <div class="price-section-textbox">
                              <div class="price-section-text-div">
                                <p>
                                  Your {{ amount_type }} Price
                                </p>
                              </div>

                            </div>
                            <div class="price-section-value-div">
                              <p>£ {{ amount }}</p>
                            </div>
                          </div>
                          <form ref="paymentForm" :action="postUrl" method="post" v-if="reference" @submit.prevent="handleSubmit">
                            <div class="button-group">
                              <button class="pay-now" type="submit">Pay Now</button>

                              <button class="pay-now" @click.prevent="payCash"> Pay by Cash </button>

                              <button class="pay-now" @click.prevent="redirectToDownloadPage()">Download App </button>
                              <button class="track-btn" v-show="showTracking && !is_archived" @click.prevent="redirectToLiveTrackingPage()"> Track Driver</button>

                              <input
                                id="Reference"
                                name="Reference"
                                type="hidden"
                                :value="reference"
                              />
                            </div>
                          </form>
                          <div v-if="showCharityDiv && reference">
                            <ul class="demo-alignment">
                              <li>
                                <vs-checkbox v-model="payForCharity" />
                              </li>
                              <li @click="openCharityDescription">
                                {{ charityText }}
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div v-else>
                            <div class="payment-container">
                              <p class="payment-status">NOT PAID</p>
                              <p class="payment-message">
                                Please wait for the driver to send the price at the end of your journey. If the price isn't displayed please ask your driver to authorise your payment. It will display here
                              </p>
                              <div class="loading-spinner">
                                <span class="spinner"></span>
                              </div>
                              <p class="or-text">OR</p>
                              <div class="button-group">
                                <button class="pay-now" @click="payCash">Pay by Cash</button>
                                <button class="pay-now" @click="redirectToDownloadPage()">Download App</button>
                                <button class="track-btn"  v-show="showTracking && !is_archived" @click="redirectToLiveTrackingPage()">Track Driver</button>
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>

                                  <!--
                              /************************************************************************************************** */

                              /*********************************** VARIABLE PRICE *************************************** */

                              /************************************************************************************************** */-->

                  <div v-else>
                    <div class="booking-confirmation" v-if="payment_done_case">
                      <div class="gradient-border">
                        <h4 class="mb-4">PLEASE SHOW THIS TO YOUR DRIVER</h4>
                         <p>Amount Paid: &#163; {{ bookingPaymentAmount }} </p>
                        <p>Booking ID: {{ decryptedBookingId }}</p>
                        <p>AuthCode: {{ authcode }}</p>

                        <p  v-if="status == 'booked' || status == 'active' || status == 'offered'">
                          PAID BEFORE JOURNEY
                        </p>
                        <p v-else v-show="showTracking">DRIVER CALLSIGN : {{ driverCallsign }}</p>

                      </div>
                      <div class="buttons">
                        <button class="pay-now" @click="redirectToDownloadPage()">Download App</button>
                        <button class="track-btn"  v-show="showTracking &&  !is_archived" @click="redirectToLiveTrackingPage()">Track Driver</button>
                      </div>
                    </div>
                    <div v-else>
                      <div v-if="is_locked && payment_type=='Card'"
                        class="panel panel-default widget-weather panel-body"
                      >
                         <div class="price-section">
                          <div class="price-section-textbox">
                            <div class="price-section-text-div">
                              <p>
                                Your {{ amount_type }} Price
                              </p>
                            </div>

                          </div>
                          <div class="price-section-value-div">
                            <p>£ {{ amount }}</p>
                          </div>
                        </div>
                        <form ref="paymentForm" :action="postUrl" method="post" v-if="reference" @submit.prevent="handleSubmit">
                          <div class="button-group">
                            <button class="pay-now" type="submit"> Pay Now </button>
                            <button class="pay-now" @click.prevent="payCash"> Pay by Cash </button>
                            <button class="pay-now" @click.prevent="redirectToDownloadPage()"> Download App </button>
                            <button class="track-btn" v-show="showTracking && !is_archived" @click.prevent="redirectToLiveTrackingPage()"> Track Driver </button>
                            <input
                              id="Reference"
                              name="Reference"
                              type="hidden"
                              :value="reference"
                            />
                          </div>
                        </form>
                        <div v-if="showCharityDiv && reference">
                          <ul class="demo-alignment">
                            <li>
                              <vs-checkbox v-model="payForCharity" />
                            </li>
                            <li @click="openCharityDescription">
                              {{ charityText }}
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div v-else-if="checkaccount || cashMeterJob">
                        <h3>
                          {{ this.accountBookingText }}
                        </h3>
                        <div class="button-group">
                            <button class="track-btn" v-show="showTracking && !is_archived" @click.prevent="redirectToLiveTrackingPage()"> Track Driver</button>
                        </div>
                      </div>
                      <div v-else-if="payment_type == null || payment_type == 'Cash'" >
                        <div class="mt-6 gap-4 flex justify-end">
                            <button class="pay-now" @click="redirectToDownloadPage()">Download App</button>
                            <button class="track-btn"  v-show="showTracking  && !is_archived" @click="redirectToLiveTrackingPage()">Track Driver</button>
                        </div>
                        <h4 class="flex justify-center mt-4">You want to pay by card ?</h4>
                        <div class="flex gap-4 justify-center mt-4">
                            <button class="pay-now" @click="payByCard">Yes </button>
                            <button  class="pay-now" > No </button>
                        </div>
                      </div>
                      <div v-else>
                        <div class="payment-container">
                            <p class="payment-status">NOT PAID</p>
                            <p class="payment-message">
                              Please wait for the driver to send the price at the end of your journey. If the price isn't displayed please ask your driver to authorise your payment. It will display here
                            </p>
                            <div class="loading-spinner">
                              <span class="spinner"></span>
                            </div>
                            <p class="or-text">OR</p>
                            <div class="button-group">
                              <button class="pay-now" @click="payCash">Pay by Cash</button>
                              <button class="pay-now" @click="redirectToDownloadPage()">Download App</button>
                              <button class="track-btn"  v-show="showTracking && !is_archived" @click="redirectToLiveTrackingPage()">Track Driver</button>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                 <div class="booking-confirmation" v-if="payment_done_case">
                    <div class="gradient-border">
                      <h4 class="mb-4">PLEASE SHOW THIS TO YOUR DRIVER</h4>
                      <p>Amount Paid: &#163; {{ bookingPaymentAmount }} </p>
                      <p>Booking ID: {{ decryptedBookingId }}</p>
                      <p>AuthCode: {{ authcode }}</p>
                      <p v-if="status == 'booked' || status == 'active' || status == 'offered'">
                        PAID BEFORE JOURNEY
                      </p>
                      <p v-else v-show="showTracking">DRIVER CALLSIGN : {{ driverCallsign }}</p>

                    </div>
                    <div class="buttons">
                      <button class="pay-now" @click="redirectToDownloadPage()">Download App</button>
                      <button class="track-btn"  v-show="showTracking  && !is_archived" @click="redirectToLiveTrackingPage()">Track Driver</button>
                    </div>
                  </div>
                  <div v-else-if="checkaccount">
                    <h3>
                      {{ this.accountBookingText }}
                    </h3>
                    <div class="button-group">
                        <button class="track-btn" v-show="showTracking && !is_archived" @click.prevent="redirectToLiveTrackingPage()"> Track Driver</button>
                      </div>
                  </div>
                  <div
                    v-else
                    class="panel panel-default widget-weather panel-body"
                  >
                     <div class="price-section">
                      <div class="price-section-textbox">
                        <div class="price-section-text-div">
                          <p>
                            Your {{ amount_type }} Price
                          </p>
                        </div>

                      </div>
                      <div class="price-section-value-div">
                        <p>£ {{ amount }}</p>
                      </div>
                    </div>
                    <form ref="paymentForm" :action="postUrl" method="post" v-if="reference" @submit.prevent="handleSubmit">
                      <div class="button-group">
                        <button class="pay-now" type="submit">Pay Now</button>

                        <button class="pay-now" @click.prevent="redirectToDownloadPage()">Download App</button>
                        <button class="track-btn" v-show="showTracking && !is_archived" @click.prevent="redirectToLiveTrackingPage()"> Track Driver</button>
                        <input
                          id="Reference"
                          name="Reference"
                          type="hidden"
                          :value="reference"
                        />
                      </div>
                    </form>
                    <div v-if="showCharityDiv && reference">
                      <ul class="demo-alignment">
                        <li>
                          <vs-checkbox v-model="payForCharity" />
                        </li>
                        <li @click="openCharityDescription">
                          {{ charityText }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" v-show="status == 'archived'">
                <p class="error">
                  You cannot edit, track or process a payment for this booking at this time as
                  it might be completed, cancelled or the driver could not find
                  you
                </p>
                <div class="buttons">
                  <button class="call-us" @click="callUs()">Call Us</button>
                  <button class="pay-now" @click="redirectToDownloadPage()">Download App</button>
                </div>
              </div>
            </div>
            <div
              v-else-if="
                !manually_allowed_check && manually_allowed_check != null
              "
            >
              Manual Booking Is Not Allowed To Do Payment
            </div>

          </div>

        </div>

    </div>
  </div>
    <vs-popup class="holamundo"  title="Edit Booking" :active.sync="editBookingPopup">
    <div class="booking-status-area">
      <div class="booking-status-text-area">
        <div class="booking-status-text-div">
          <p>{{ status === "booked"
                ? "Advanced" : capitalizeFirst(status) }} Booking {{payment_done_case? 'Paid':'UnPaid'}}</p>
        </div>
      </div>
    </div>
    <div>
      <form @submit.prevent="editBooking">
        <div class="vx-row sm:mb-4 mb-6 mob-view">
          <div class="vx-col sm:w-1/2 w-full">
            <label class="ml-2  vs-input--label" for="">Date</label>
            <datepicker @input="onInputChange" :disabledDates="disabledDates" :disabled="!bookingEditableFields.date.visible"  v-model="bookingEditableFields.date.value" format="dd/MM/yyyy" placeholder="01/01/2025" input-class="vs-con-input-label vs-input w-full " calendar-class="vs-input"/>
						<!-- <vs-input class="custom-label w-full" label="Date" placeholder="01/01/2025"  /> -->
					</div>
					<div class="vx-col sm:w-1/2 w-full">
            <label class="ml-2  vs-input--label" for="">Time</label>

						<input id="time" :disabled="!bookingEditableFields.time.visible" type="time" class="vs-con-input-label time-input vs-input--input normal w-full" v-model="bookingEditableFields.time.value" :min="timeMin" step="60"/>

					</div>
				</div>

        <div class="vx-row sm:mb-4 mb-6  mob-view-2">
					<div class="vx-col sm:w-1/2 w-full">
            <label class="ml-2 vs-input--label" for="">Pickup</label>
             <gmap-autocomplete
                    :disabled="!bookingEditableFields.pickup.visible"
                    ref="pickupAutocomplete"
                    class="vs-inputx vs-input--input normal w-full h-38"
                    @place_changed="setPlace"
                    label-placeholder="Pickup"
                    placeholder="Pickup"
                    name="pickup"
              ></gmap-autocomplete>

						<!-- <input class="vs-inputx vs-input--input normal w-full" placeholder="Pickup" v-model="bookingEditableFields.pickup"/> -->

					</div>
          <div class="vx-col sm:w-1/2 w-full">
            <label class="ml-2 vs-input--label" for="">DropOff</label>
             <gmap-autocomplete
                    :disabled="!bookingEditableFields.dropOff.visible"
                    ref="dropoffAutocomplete"
                    class="vs-inputx vs-input--input normal w-full h-38"
                    @place_changed="setPlace2"
                    label-placeholder="DropOff"
                    placeholder="DropOff"
                    name="dropoff"
              ></gmap-autocomplete>

					</div>
				</div>
        <div class="vx-row sm:mb-4 mb-6  mob-view">
					<div class="vx-col w-full">
            <label class="ml-2 vs-input--label" for="">Vehicle type</label>

          <v-select  :disabled="true"   :clearable="false" :options="vehicleOptions" v-validate="'required'" name="vehicleType" />


						<!-- <input class="vs-inputx vs-input--input normal w-full" placeholder="Standard" v-model="bookingEditableFields.vehicleType"/> -->
					</div>
				</div>
        <div class="vx-row sm:mb-4 mb-6 ">
          <div class="vx-col  w-full">
            <label class="ml-2 vs-input--label" for="">Name</label>
						<input class="vs-inputx vs-input--input normal w-full h-38" v-model="bookingEditableFields.name.value"/>
          </div>
				</div>
        <div class="vx-row mb-6" >
          <div class="vx-col  w-full vs-component vs-con-input-label vs-input" >
            <label class="ml-2  vs-input--label" for="">Driver notes</label>
						<textarea  v-model="bookingEditableFields.driverNotes.value" class="vs-inputx vs-input--input normal w-full" height="100px"  label="Driver notes" placeholder=""  />
          </div>
				</div>
      <vs-divider/>
      <vs-row class="mt-4 gap-4" vs-type="flex" vs-justify="space-between" >
      <button  class="cancel-btn" @click.prevent="editBookingPopup = false">  Cancel  </button>
      <button class="track-btn" type="submit">  Save  </button>
      </vs-row>

    </form>
    </div>

    </vs-popup>

  </div>
</template>


<script>

import { MAIN_DOMAIN, WEB_SERVER_HOST } from "@/environment/index";
import Echo from "laravel-echo";
import Datepicker from 'vuejs-datepicker'
import vSelect from 'vue-select'
import moment from "moment";


window.io = require("socket.io-client");

window.Echo = new Echo({
  broadcaster: "socket.io",
  host: WEB_SERVER_HOST,
  authEndpoint: "/broadcasting/auth",
});

import * as axios from "@/services/Axios";

import {
  _getBooking,
  _asCardPayment,
  _asCashPayment,
  _getReceipt
} from "@/services/Payment";

import { _editBooking } from "@/services/Booking";
import { _recordAnalytics } from "@/services/analytics";
Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

export default {
  watch: {
    payForCharity(val) {
      if (val) {
        this.calculateAmountWithCharity();
        this.prepaycall(true);
      } else {
        this.amount = this.beforeCharityAmount;
        this.charityAmount = 0.0;
        this.prepaycall();
      }
    },
    cashMeterJob(val) {
      // Always set accountBookingText when cashMeterJob is true
      if (val) {
        this.accountBookingText = "The following booking is on cash meter job. Not allowed in this version of Infocab";
      }
    }
  },
  components: {
    Datepicker,
    vSelect
  },
  data() {
    return {
      vehicleOptions: [
        {
          label: 'Standard',
          id : -1
        },
        {
          label: '6 Seater',
          id : 1
        },
        {
          label: '8 Seater',
          id : 3
        }
      ],

      bookingEditableFields:{
        date: { value: null, visible: true },
        time: { value: null, visible: true },
        pickup: { value: null, lat: null, lng:null, visible: true },
        dropOff: { value: null, lat: null, lng:null, visible: true },
        vehicleType: { value: {id:'',value: ''}, visible: true },
        name: { value: null, visible: true },
        driverNotes: { value: null, visible: true }
      },
      editBookingPopup:false,
      current_company: null,
      charityDescriptionPopup: false,
      postUrl: null,
      reference: null,

      amount: 0,
      pickup: "",
      destination: "",
      bid: this.$route.params.bid,
      booking_found: false,
      is_archived: false,
      checkezp: false,
      checkaccount: false,

      payment_type: null,

      pay_by_card_screen: true,
      variable_cost: false,
      pay_reference: "",

      is_dispatched: false,
      is_fixed_price: false,
      is_as_directed: false,
      amount_type: "Fixed",

      payment_done_case: false,

      status: "",
      got_variable_price: false,
      is_locked: false,

      is_manual_booking: null,
      allow_manual_booking: null,
      manually_allowed_check: null,
      phonenumber: null,

      authcode: null,
      decryptedBookingId: null,
      bookingPickupTime: null,
      driverCallsign: null,

      ghostBooking: null,
      admin_allow_third_party: null,
      quoteData: null,
      booking_type: null,

      showCharityDiv: false,
      charityText: "",
      charityDescription: "",
      payForCharity: false,
      charityAmount: 0.0,
      newAmount: 0.0,
      beforeCharityAmount: this.amount,
      companyLogo: null,

      isAndroid: false,
      isIphone: false,
      isWindows: false,
      isMac:false,
      email: null,
      paidPaymentReference: null,
      bookingPaymentAmount: null,
      systemId: null,
      showTracking: false,
      showEditing: false,
      disabledDates: {
        to: null
      },
      _editableDate:null,
      selectedVehicle: null,
      payment_status: null,
      timeMin: null,
      company_number: null,
      provider: null,
      cashMeterJob: false,
      // meterAsAccount: false,
      manuallyFixedPriceJob: false,
      accountBookingText: 'The following booking is on an invoiced account and cannot be changed into a non account booking',

    };
  },
  mounted() {
    document.title = "NUDG Web Application";
    const favicon = document.getElementById("favicon");
    if (favicon) {
      favicon.href =  `${process.env.BASE_URL}nudgpay-favicon.ico`;//require("@/assets/images/logo/nudgtrack-favicon.ico");
    }
  //  setTimeout(() => {
  //       const loadingImg = document.getElementById('loadingImg');
  //       if (loadingImg) {
  //         loadingImg.src = require('@/assets/images/logo/track-title-logo.png'); // Ph to the new image
  //       } else {
  //         console.error("Could not find the element with ID 'loadingImg'");
  //       }
  //   }, 5000); // Adjust timeout as needed to allow for DOM load



    this.detectDevice();
    // initialize min time based on current UK time and selected date
    this.updateTimeMin();
  },
  watch: {
    'bookingEditableFields.date.value': function () {
      this.updateTimeMin();
    }
  },

  beforeMount() {
    document.documentElement.style.overflow = "hidden";
    this.$vs.loading();

    _getBooking(this.bid).then(
      (res) => {
        this.decryptedBookingId = res.data.obj.decrypt_booking_id;
        this.current_company = res.data.obj.company_id;
        this.systemId = res.data.obj.system_id;
        this.provider = res.data.obj.booking_provider;

        switch (this.systemId) {
          case 770:  // worthing
              this.showTracking = true;
              this.showEditing = true;
              break;
          case 421: // nova
              this.showTracking = true;
              this.showEditing = true;
              break;

          case 9: //dg
              this.showTracking = true;
              this.showEditing = true;
              break;

          // case 969: // coal
          //     this.showTracking = true;
          //     this.showEditing = true;
          //     break;

          case 135: // info
              this.showTracking = true;
              this.showEditing = true;
              break;

          case 326:  // info beta
              this.showTracking = true;
              this.showEditing = true;
              break;

          case 305:  // info beta
              this.showTracking = true;
              this.showEditing = true;
              break;


          default:
              this.showTracking = false;
              this.showEditing = false;
              break;
        }
        this.company_number = res.data.obj.company_number ? res.data.obj.company_number : '1159500500';
       

        this.listen();
        this.listenForAnyChange();
        this.companyLogo = res.data.obj.company_logo
          ? MAIN_DOMAIN + res.data.obj.company_logo
          : null;
        this.showCharityDiv = res.data.obj.is_charity_enable;
        this.booking_type = res.data.obj.booking.bookingType;
        this.admin_allow_third_party = res.data.obj.admin_allow_third_party;
        this.quoteData = res.data.obj.getquotedata;
        this.ghostBooking = res.data.obj.booking;

        this.setBookingEditableFields(this.ghostBooking);
        this.pickup = res.data.obj.pickup;
        this.destination = res.data.obj.destination;
        this.checkaccount = res.data.obj.checkaccount;


        if(this.provider == 'infocab') {
          
          if(this.ghostBooking.paymentType !== 'Account'){
          if(this.ghostBooking.pricing.fareType == 'Meter'){
            this.checkaccount = true;
            this.cashMeterJob = true;
            this.accountBookingText = "The following booking is on cash meter job. Not allowed in this version of Infocab";
            // accountBookingText will be set automatically by the watcher
          }
          else if(this.ghostBooking.pricing.fareType == 'Fixed' && this.ghostBooking.pricing.appliedTariffName == 'Manually entered'){
            this.manuallyFixedPriceJob = true;
          }
        }
      }

        this.paidPaymentReference = res.data.obj.payment;

        this.checkezp = res.data.obj.checkezp;
        if (this.checkezp) this.payment_done_case = true;

        this.is_as_directed = res.data.obj.is_as_directed;
        this.is_dispatched = res.data.obj.is_dispatched;
        this.is_fixed_price = res.data.obj.is_fixed_price;
        this.amount = res.data.obj.price;
        this.is_archived = res.data.obj.is_archived;
        this.pay_reference = res.data.obj.payment_ref;
        this.status = res.data.obj.booking_status;
        this.payment_type = res.data.obj.payment_type;

        this.booking_found = true;
        this.variable_cost = res.data.obj.variable_cost;
        this.is_locked = res.data.obj.is_locked;
        this.is_manual_booking = res.data.obj.is_manual_booking;
        this.allow_manual_booking = res.data.obj.allow_manual_booking;
        this.phonenumber = res.data.obj.cust_ref;
        this.bookingPaymentAmount = res.data.obj.payment_amount;
        this.payment_status = res.data.obj.payment_status;

        if (this.admin_allow_third_party) {
          if (
            (!this.checkezp &&
              this.is_fixed_price &&
              this.payment_type == "Card") ||
            this.payment_type == "Card" ||
            ((this.status == "active" || this.status == "booked" || this.status == "offered") &&
              this.is_fixed_price)
          ) {
            if (!this.is_archived && this.is_locked && !this.is_fixed_price)
              this.prepaycall();
            else if (!this.is_archived && this.is_fixed_price) this.prepaycall();

            else if (!this.is_archived && (this.status == 'booked' || this.status == 'offered') && !this.payment_done_case ) {
              console.log('herr');

              this.prepaycall();
            }
          }
        } else {
          if (!this.checkezp && !this.is_archived) this.prepaycall();
        }

        if (this.is_manual_booking) {
          this.manually_allowed_check = this.allow_manual_booking
            ? true
            : false;
        } else {
          this.manually_allowed_check = true;
        }

        this.authcode = res.data.obj.authcode;
        this.bookingPickupTime = res.data.obj.booking_pickup_due_time;
        this.driverCallsign = res.data.obj.driver_callsign;
        this.admin_allow_third_party = res.data.obj.admin_allow_third_party;

        this.charityText = res.data.obj.charity
          ? res.data.obj.charity.title
          : "";
        this.charityDescription = res.data.obj.charity
          ? res.data.obj.charity.description
          : "";

      this.setVehicleType(this.ghostBooking.capabilities)
       const today = new Date();
        today.setHours(0, 0, 0, 0); // Ensure the time is midnight
        this.disabledDates.to = today; // Disable dates before today
        // Set field editability based on initial status
        this.setFieldEditability();
        this.$vs.loading.close();
        // Set pickup and dropoff places after DOM is ready
        this.$nextTick(() => {
          this.setPickupPlace(this.pickup);
          this.setDropoffPlace(this.destination);
        });
      },
      (error) => {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Error",
          text: error.response.data.message,
          iconPack: "feather",
          icon: "icon-cross-circle",
          color: "danger",
        });
      }
    );
  },
  methods: {
    getUkTimeString() {
      const now = new Date();
      // Convert to UK time string
      const ukTimeString = now.toLocaleString('en-GB', { 
        timeZone: 'Europe/London',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
      
      return ukTimeString;
    },

    updateTimeMin() {
      const nowUkStr = this.getUkTimeString();
      const selected = this.bookingEditableFields.date.value;
      
      if (!selected) {
        this.timeMin = nowUkStr;
        return;
      }
      
      // Check if selected date is today
      const today = new Date();
      const selectedDate = new Date(selected);
      
      // Compare year, month, and day
      const isToday = today.getFullYear() === selectedDate.getFullYear() &&
                      today.getMonth() === selectedDate.getMonth() &&
                      today.getDate() === selectedDate.getDate();
      
      this.timeMin = isToday ? nowUkStr : null;
      
      console.log('Time Min updated:', {
        nowUkStr,
        isToday,
        timeMin: this.timeMin,
        selected: selected
      });
    },
    async handleSubmit() {
      await this.$nextTick(); // Ensures the form is mounted after any condition changes

      const form = this.$refs.paymentForm;
      if (!form) {
        console.error('Form not found');
        return;
      }
      try {
        // Call analytics API before submitting
        await _recordAnalytics({
          booking_id: this.decryptedBookingId, // Use your booking ID or reference
          button_type: 'pay_now',
          system_id: this.systemId
        });

        console.log('Analytics Tracked!');

        // Now, submit the form manually
        form.submit();

      } catch (error) {
        console.error('Error tracking Pay Now button:', error);
      }
    },
  onInputChange(selectedDate){
      const date = new Date(selectedDate);

      // Extract the year, month, and day
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const day = String(date.getDate()).padStart(2, '0');

      // Format as YYYY-MM-DD
      this._editableDate = `${year}-${month}-${day}`;
      return this._editableDate;
    },
    reloadPage(){
       window.location.reload();
    },
    editBooking() {
      this.$vs.loading({ text: "Saving modifications...." });

    this.bookingEditableFields.vehicleType.value =  this.selectedVehicle
      const apiPayload = Object.fromEntries(
        Object.entries(this.bookingEditableFields).map(([key, field]) => [key, field.value])
      );


      const editData = {
        ...apiPayload, 'systemId' : this.systemId,
        'pickupLat': this.bookingEditableFields.pickup.lat,
        'pickupLng': this.bookingEditableFields.pickup.lng,
        'dropOffLat': this.bookingEditableFields.dropOff.lat,
        'dropOffLng': this.bookingEditableFields.dropOff.lng,
        'bookingStatus' : this.status,
        'payment_status': this.payment_status
      }
      editData.date = this.onInputChange(editData.date);

      console.log(editData);
      _editBooking(this.decryptedBookingId, editData).then(
      (res) => {

        if(!res.data.obj.status_changed) {
          this.editBookingPopup = false;
          this.$vs.loading.close();
          if (res.data.obj.refresh) {
            this.$vs.notify({ color: '#79E864', title: 'Modified Success', text: 'Booking has been modified. Reloading booking' })
            setTimeout(() => {
              this.reloadPage();
            }, 3000); // 1000 milliseconds = 1 second
          }
          else {
            this.$vs.notify({ color: '#79E864', title: 'Modified Success', text: 'Booking has been modified' })
          }
        }

        else {
           this.editBookingPopup = false;
          this.$vs.loading.close();
            this.$vs.dialog({
              color: 'danger',
              title: 'Booking update response',
              text: 'Booking status mismatched. You need to refresh ',
              accept:this.reloadPage
            });
          }
      },
      (error) => {
        this.$vs.loading.close();
        console.log(error.response.data);
        this.$vs.notify({
          title: "Error",
          text: error.response.data.responseMessage,
          iconPack: "feather",
          icon: "icon-cross-circle",
          color: "danger",
        });
      }

      );
    },
    capitalizeFirst(value) {
      if (!value) return '';
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    setPickupPlace(val) {
      if (this.$refs.pickupAutocomplete && this.$refs.pickupAutocomplete.$refs && this.$refs.pickupAutocomplete.$refs.input) {
        this.$refs.pickupAutocomplete.$refs.input.value = val;
      }
    },

    formatPlaceAddress(place) {
      if (!place || !place.formatted_address) {
        return '';
      }

      const formattedAddress = place.formatted_address.trim();
      let addressText = formattedAddress;

      // Only add place.name if it's not already included in formatted_address
      if (place.name && place.name.trim()) {
        const placeName = place.name.trim();
        
        // Check if the place name is already represented in the formatted address
        if (!this.isPlaceNameInAddress(placeName, formattedAddress)) {
          addressText = `${placeName} , ${formattedAddress}`;
        }
      }

      return addressText.replace(/,/g, '').toUpperCase();
    },

    isPlaceNameInAddress(placeName, formattedAddress) {
      // Normalize strings for comparison
      const normalize = (str) => str.toLowerCase().trim().replace(/\s+/g, ' ');
      const normalizedName = normalize(placeName);
      const normalizedAddress = normalize(formattedAddress);
      
      // Split into words
      const nameWords = normalizedName.split(' ');
      const addressWords = normalizedAddress.split(' ');
      
      // Check if we have enough words in address to match the name
      if (nameWords.length > addressWords.length) {
        return false;
      }
      
      // Compare word-by-word, handling abbreviations
      return nameWords.every((nameWord, index) => {
        const addressWord = addressWords[index];
        if (!addressWord) return false;
        
        // Exact match
        if (nameWord === addressWord) return true;
        
        // Check if one is an abbreviation of the other
        return this.wordsMatch(nameWord, addressWord);
      });
    },

    wordsMatch(word1, word2) {
      // Normalize both words (remove punctuation, lowercase)
      const normalize = (w) => w.toLowerCase().replace(/[.,]/g, '');
      const w1 = normalize(word1);
      const w2 = normalize(word2);
      
      // Exact match
      if (w1 === w2) return true;
      
      // Check if one word is contained in the other (handles abbreviations)
      // e.g., "street" contains "st", "st" is contained in "street"
      if (w1.includes(w2) || w2.includes(w1)) {
        // But only if the shorter word is at least 2 characters to avoid false positives
        const shorter = w1.length < w2.length ? w1 : w2;
        if (shorter.length >= 2) {
          return true;
        }
      }
      
      // Check if words start with the same characters (handles partial matches)
      // e.g., "street" and "st" both start with "st"
      const minLength = Math.min(w1.length, w2.length);
      if (minLength >= 2 && w1.substring(0, minLength) === w2.substring(0, minLength)) {
        return true;
      }
      
      // Calculate simple similarity (Levenshtein-like but simpler)
      // If words are very similar (differ by 1-2 characters), consider them a match
      const longer = w1.length > w2.length ? w1 : w2;
      const shorter = w1.length <= w2.length ? w1 : w2;
      
      if (longer.length >= 3 && shorter.length >= 2) {
        // Check if shorter word appears at the start of longer word
        if (longer.startsWith(shorter)) {
          return true;
        }
        // Check similarity: if longer word is just shorter + 1-2 chars, likely a match
        if (longer.length - shorter.length <= 2 && longer.startsWith(shorter.substring(0, Math.max(2, shorter.length - 1)))) {
          return true;
        }
      }
      
      return false;
    },

    setPlace(place) {
    if(this.provider == 'infocab') {
      this.bookingEditableFields.pickup.value = this.formatPlaceAddress(place);
      this.bookingEditableFields.pickup.lat = place.geometry.location.lat();
      this.bookingEditableFields.pickup.lng = place.geometry.location.lng();
    }

    else {
      this.bookingEditableFields.pickup.value = place.formatted_address;
      this.bookingEditableFields.pickup.lat = place.geometry.location.lat();
      this.bookingEditableFields.pickup.lng = place.geometry.location.lng();
      }
    },
    setDropoffPlace(val) {
      if (this.$refs.dropoffAutocomplete && this.$refs.dropoffAutocomplete.$refs && this.$refs.dropoffAutocomplete.$refs.input) {
        this.$refs.dropoffAutocomplete.$refs.input.value = val;
      }
    },

    setPlace2(place) {
      if(this.provider == 'infocab') {    
        this.bookingEditableFields.dropOff.value = this.formatPlaceAddress(place);
        this.bookingEditableFields.dropOff.lat = place.geometry.location.lat();
        this.bookingEditableFields.dropOff.lng = place.geometry.location.lng();
      }
      else {
        this.bookingEditableFields.dropOff.value = place.formatted_address;
        this.bookingEditableFields.dropOff.lat = place.geometry.location.lat();
        this.bookingEditableFields.dropOff.lng = place.geometry.location.lng();
      }
    },

    setFieldEditability() {
      // Only set field editability if showEditing is true
      if (!this.showEditing) {
        return;
      }
      if(this.payment_done_case || this.manuallyFixedPriceJob) {
        this.bookingEditableFields.date.visible = false;
        this.bookingEditableFields.time.visible = false;
        this.bookingEditableFields.pickup.visible = false;
        this.bookingEditableFields.dropOff.visible = false;
        // this.bookingEditableFields.vehicleType.visible = true;
      }
      else {
        if(this.status == 'archived' || this.status == 'complete' || this.status == 'completed' || this.status == 'cancelled') {
          this.bookingEditableFields.date.visible = false;
          this.bookingEditableFields.time.visible = false;
          this.bookingEditableFields.pickup.visible = false;
          this.bookingEditableFields.dropOff.visible = false;
          this.bookingEditableFields.name.visible = false;
          this.bookingEditableFields.driverNotes.visible = false;
          this.editBookingPopup = false;
          this.showEditing = false;
        }
        else {
          if (this.status == 'dispatched' || this.status == 'arrived' || this.status == 'pickedup') {
              this.bookingEditableFields.date.visible = false;
              this.bookingEditableFields.time.visible = false;
              this.bookingEditableFields.pickup.visible = false;
              if(this.provider == 'infocab' && this.status == 'pickedup') {
              this.bookingEditableFields.dropOff.visible = false;
              }
              else {
                this.bookingEditableFields.dropOff.visible = true;
              }
          }
          else {
              this.bookingEditableFields.date.visible = true;
              this.bookingEditableFields.time.visible = true;
              this.bookingEditableFields.pickup.visible = true;
              this.bookingEditableFields.dropOff.visible = true;
            }
        }
      }
    },

    convertToDate(dateString) {
      // Rearrange DD/MM/YYYY to YYYY-MM-DD
      const [day, month, year] = dateString.split('/');
      const formattedDateString = [year, month, day].join('-');
      return new Date(formattedDateString);
    },

    setBookingEditableFields(booking) {
      const utcTime = booking.pickupDueTimeUtc; // e.g., "2025-05-20T20:00:00.0000000Z"

      const dateObj = new Date(utcTime);

      // Format to UK local time
      const options = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false, // Set to false for 24hr format
        timeZone: 'Europe/London', // UK timezone
      };

      const formattedTime = dateObj.toLocaleTimeString('en-GB', options);

      // Optional: Format date too
      const formattedDate = dateObj.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        timeZone: 'Europe/London',
      });

      // const [date, timeWithZone] = booking.pickupDueTimeUtc.split('T');
      // const formattedDate = this.convertToDate(date);
      // const formattedTime = timeWithZone.substring(0, 5);

      this.bookingEditableFields.date.value = formattedDate;
      this.bookingEditableFields.time.value = formattedTime;
      this.bookingEditableFields.pickup.value = booking.pickup.address.text;
      this.bookingEditableFields.pickup.lat = booking.pickup.address.coordinate.latitude;
      this.bookingEditableFields.pickup.lng = booking.pickup.address.coordinate.longitude;
      this.bookingEditableFields.dropOff.value = booking.destination.address.text;
      this.bookingEditableFields.dropOff.lat = booking.destination.address.coordinate.latitude;
      this.bookingEditableFields.dropOff.lng = booking.destination.address.coordinate.longitude;
      // this.bookingEditableFields.vehicleType.value = this.setVehicleType(booking.capabilities);
      this.bookingEditableFields.name.value = booking.name;
      this.bookingEditableFields.driverNotes.value = booking.driverNote;



      document.querySelectorAll('.pac-container').forEach((el) => {
        el.style.zIndex = '900000';
      });

    },
    setVehicleType(capabilities) {
      console.log(capabilities.length );
      if (capabilities.length == 0 ) {
          this.selectedVehicle = this.vehicleOptions[0]
          return;
      }
      else {
        switch (capabilities[0]) {
          case 1:
            this.selectedVehicle = this.vehicleOptions[1]
            break;
          case 3:
            this.selectedVehicle = this.vehicleOptions[2]
            break;

          default:
            break;
        }

      }
    },
    editClick() {
      _recordAnalytics({
        'booking_id' : (this.decryptedBookingId).toString(),
        'button_type' : 'edit',
        'system_id' : this.systemId
        }).then(
        (res) => {
          this.editBookingPopup = true;
          // Set field editability after popup is rendered
          this.$nextTick(() => {
            this.setFieldEditability();
          });
        });

    },

    callUs() {
      window.location.href = 'tel:+44' + this.company_number; // Replace with your phone number
    },

    async redirectToDownloadPage() {

    try {
      await _recordAnalytics({
            'booking_id' : (this.decryptedBookingId).toString(),
            'button_type' : 'download',
            'system_id' : this.systemId
          }).then((res)=> {
            console.log(res);

          });
          if (this.isAndroid || this.isWindows) {
            const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.dggroup.nudg.user.app&hl=en_US';
            window.location.href = playStoreUrl;
          } else if (this.isIphone || this.isMac) {
            const appleStoreUrl = 'https://apps.apple.com/gb/app/nudg-fast-safe-taxi-booking/id1618819793';
            window.location.href = appleStoreUrl;
          } else {
            console.log('what type of device is this ??');
          }

        } catch (error) {

        }
    },
    redirectToLiveTrackingPage() {
      _recordAnalytics({
        'booking_id' : (this.decryptedBookingId).toString(),
        'button_type' : 'tracking',
        'system_id' : this.systemId

      }).then(
      (res) => {
        this.$router.push({ name: 'LiveTracking' });
      });
    },

    logAnalytic(btnType) {
       _recordAnalytics({
        'booking_id' : (this.decryptedBookingId).toString(),
        'button_type' : btnType,
        'system_id' : this.systemId
      }).then(
      (res) => {
        console.log(res)
      });
    },

    detectDevice() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Detect Android
      if (/android/i.test(userAgent)) {
        console.log('android');

        this.isAndroid = true;
      }

      // Detect iPhone
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        console.log('iphone');
        this.isIphone = true;
      }

      // Windows
      if (/windows phone/i.test(userAgent) || /win/i.test(userAgent)) {
        this.isWindows = true;
        console.log('windows');
      }

       // Mac OS
      if (/macintosh|mac os x/i.test(userAgent)) {
        console.log('mac');

        this.isMac = true;
      }

    },
    payByCard() {
      _asCardPayment({ bid: this.bid }).then(
        (res) => {
          if (res.data.obj.errorCode == "0") {
            if (this.is_fixed_price) {
              // console.log("1");
              this.prepaycall();
            } else {
              if (this.is_locked) {
                // console.log(this.is_locked);
                // console.log("2");
                this.prepaycall();
              }
            }
            this.payment_type = "Card";
          }
        },
        (error) => {
          if (
            error.response.data.errors.errorCode == "3" ||
            error.response.data.errors.errorCode == "4"
          ) {
            this.status = "archived";
            this.is_archived = true;
          }
          console.log(error.response.data.errors.errorCode);
        }
      );
    },
    payCash() {
      _asCashPayment({ bid: this.bid }).then(() => {
        this.payment_type = "Cash";
      });
    },
    listenForAnyChange() {
     window.Echo.channel(`booking.${this.decryptedBookingId}`).listen(
        "GeneralBookingEvent",
          (e) => {
          // accountBookingText is automatically maintained by the cashMeterJob watcher
          console.log(e);
          if(this.cashMeterJob) {
            this.accountBookingText = "The following booking is on cash meter job. Not allowed in this version of Infocab";
          }
          if(e.request_payload.EventType == 'BookingModified') {
            if(e.change_type == 'cost_modified')
              window.location.reload();
          }
          else if(e.change_type == 'booking_status') {
            if (e.request_payload && 'BookingStatus' in e.request_payload) {

              this.status = e.request_payload.BookingStatus;
              console.log('BookingStatus exists:', e.request_payload.BookingStatus);
              this.setFieldEditability();
              if(e.request_payload.BookingStatus == 'cancelled' || e.request_payload.BookingStatus == 'complete') {
                this.status = 'archived';
                this.editBookingPopup = false;
                this.showEditing = false;
              }
            }
          }
        });
    },
    listen() {
      window.Echo.channel(`meter-shout-booking-${this.bid}`).listen(
        "TaxiMeterShout",
        (e) => {
          if (this.admin_allow_third_party) {
            if (e.message == "vehicleDispatchEvent") {
              this.is_dispatched = true;
              this.status = "pickedup";
            } else if (e.message == "variableBooking") {
              this.is_dispatched = true;
              this.status = "pickedup";
              this.amount = null;
              this.amount_type = "Variable";
            } else {
              this.amount_type = "Variable";
              this.amount = e.data;
            }
            // this.is_locked = true;
            if (!this.is_locked && this.payment_type == "Card") {
              this.is_locked = true;
              this.prepaycall();
            }
          } else {
            // console.log('ok')
          }
        }
      );
    },
    payNow() {
      _recordAnalytics({
        'booking_id' : (this.decryptedBookingId).toString(),
        'button_type' : 'pay_now',
        'system_id' : this.systemId
      }).then(
        (res) => {
          this.$refs.pay.submit();
        });
    },
    prepaycall(charity = false) {
      if(this.payment_done_case)
        return;
      if(this.checkaccount)
        return;
      if (this.admin_allow_third_party) {
        if (this.is_fixed_price) this.amount = this.amount;
        else this.amount = this.amount ? this.amount : 0.0;
      } else {
        if (!this.is_manual_booking) {
          // if manual booking always get its price
          // if (this.booking_type == "ASAP") {
          // run quote if booking is ASAP as per ubaids command on 19-09-22
          this.amount = this.quoteData["outward"]["price"];
          // }
        }
      }
      if (charity) {
        this.amount = this.newAmount;
      }
      const data = {
        bid: this.bid,
        price: this.amount,
        charityAmount: Number(this.charityAmount),
        actualBookingPrice: this.amount - this.charityAmount,
        pickup: this.pickup,
        destination: this.destination,
        cust_reference: this.phonenumber
          ? this.phonenumber
          : Math.random().toString(36).substring(2, 7), //set to mobile number
        pay_reference: this.pay_reference,
      };
      axios.post(`booking/pay`, data).then(
        (resp) => {
          this.postUrl = resp.data.postUrl;
          this.reference = resp.data.reference;
        },
        (error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: error.response.data.responseMessage,
            text: error.response.data.errors.message,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        }
      );
    },
    calculateAmountWithCharity() {
      var newAmount;
      if (Number.isInteger(this.amount)) newAmount = this.amount + 1;
      else newAmount = Math.ceil(this.amount);
      this.charityAmount = parseFloat(newAmount - this.amount).toFixed(2);
      this.newAmount = newAmount;
      return parseFloat(newAmount - this.amount).toFixed(2);
    },

    openCharityDescription() {
      if (!this.payForCharity) this.calculateAmountWithCharity();
      this.charityDescriptionPopup = true;
    },
    getReciept() {
      if (!this.email) alert("Please enter valid email to get receipt");
      _getReceipt({ email: this.email }, this.paidPaymentReference).then(
        (res) => {
          alert('email has been sent to your given address');
          this.email ='';
          console.log(res);
        }
      );
    },
  },
};
</script>

<style scoped>
@import "./promot.css";



</style>
